import React from 'react'

const KioskWelcomeBanner = ({ assets = {} }) => (
  <div className='w-full flex flex-col gap-6'>
    <div className='flex justify-start items-center gap-4'>
      {/* Matches legacy: .new-homePage .logo { width: 152px } wrapping an img-fluid
          (max-width: 100%; height: auto) - 152px = w-38 on Tailwind's 4px spacing scale. */}
      <img src={assets.logoUrl} alt='EasyLlama' className='w-38 h-auto' />
    </div>

    <div className='border border-llama-grey-8 rounded-2xl px-4 sm:px-8 py-6'>
      <h1 className='flex flex-wrap items-center gap-2 font-[Recoleta] text-xl sm:text-2xl text-llama-grey-7 font-normal'>
        Welcome
        <img src={assets.handUrl} alt='' aria-hidden='true' className='h-7 w-7 object-contain' />
        to EasyLlama
      </h1>
      <p className='text-sm text-llama-grey-7 font-semibold mt-2'>Happy to see you back!</p>
    </div>
  </div>
)

export default KioskWelcomeBanner
